import { getNetwork } from '../utils/getNetwork';
import { API_ROOT } from '../config';

// Камеры живут на основном домене (akmsc.smartkokshetau.kz), а не на домене
// админки (akmscadmin.smartkokshetau.kz). API_ROOT в проде уже указывает на akmsc,
// поэтому базу камер выводим из него, меняя сервисный префикс /ccadmin → /akm.
// Иначе относительный путь резолвится на домен, с которого открыта админка.
const AKM_ROOT = API_ROOT.replace('/ccadmin', '/akm');

export const fetchCameraMapList = () => getNetwork().get(`${AKM_ROOT}/cameramap/list`);
